export interface HomeStat {
  title: string;
  value: string | number;
  subtitle?: string;
  color?: 'primary' | 'success' | 'error' | 'warning' | 'info';
}

// Template dos cards (título/subtítulo/cor). Os valores vêm do BFF GET /home/resumo;
// estes zeros são só o fallback enquanto o fetch não resolve.
export const homeStats: HomeStat[] = [
  { title: 'Empregadores', value: 0, subtitle: 'cadastrados', color: 'primary' },
  { title: 'Reprocessamentos ativos', value: 0, subtitle: 'em andamento', color: 'info' },
  { title: 'Pendências', value: 0, subtitle: 'requerem atenção', color: 'warning' },
  { title: 'Certidões', value: '0%', subtitle: 'regularidade', color: 'success' },
];

export interface HomeShortcut {
  label: string;
  description: string;
  path: string;
}

export const homeShortcuts: HomeShortcut[] = [
  {
    label: 'Trabalhador',
    description: 'Afastamentos, CBO e jornadas',
    path: '/esocial/trabalhador/afastamento',
  },
  {
    label: 'Saúde e segurança',
    description: 'Agentes nocivos e aposentadoria especial',
    path: '/saude-seguranca/agentes-nocivos',
  },
  {
    label: 'Folha de pagamento',
    description: 'Rubricas e empregadores',
    path: '/esocial/rubricas',
  },
  { label: 'Encargos', description: 'DCTF, mensagens e-CAC e compensação', path: '/encargos/dctf' },
  { label: 'eGov', description: 'Cessão de trabalhadores', path: '/egov/cessao' },
  { label: 'Certidões', description: 'Emitir e consultar certidões', path: '/certidoes/federal' },
];
